import './SourcesInsights.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SourcesInsightsProps {
  sourcesInsights: string[] | null;
}

const SourcesInsights: React.FC<SourcesInsightsProps> = ({ sourcesInsights }) => {
  const { t } = useTranslation();

  if (!sourcesInsights) {
    return <></>;
  }

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">{t('insightPage.sourcesInsights')}</div>
      </div>
      <div className="stats-box stats-box--list">
        <div className="stats-box__content">
          <ul>
            {sourcesInsights.map((text) => (
              <li>
                <div className="ico-box">
                  <span className="ico--eye ico--xxs" />
                </div>
                {text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SourcesInsights;
